module.exports = __webpack_public_path__ + "static/media/qr-blurry.309610f0.jpg";